module.exports = "/images/submit.svg?cbad6e68ee546d2e2a57e9b171615b9f";